import React from 'react';

import E9QuickSearch from '../ecology9/E9QuickSearch';

class E8QuickSearch extends React.Component {
  render() {
    return (
      <div className="e8header-quick-search">
        <E9QuickSearch ecId={`${(this && this.props && this.props.ecId) || ''}_E9QuickSearch@8211ov`} />
      </div>
    );
  }
}

export default E8QuickSearch;



// WEBPACK FOOTER //
// ../src4js/pc4mobx/portal4theme/components/theme/ecology8/E8QuickSearch.js